<template>
  <div class="overlayWindow">
    <div class="content" ref="window" v-bind:class="size">
      <h3 @mousedown="mousePressedOnWindow" @touchstart="touchPressedOnWindow" @touchend="mouseNotPressedOnWindow" v-bind:class="{grabbing: mousePressed}">
        <slot name="title"></slot>
      </h3>
      <button v-on:click="close()" class="close"><CloseIcon  ></CloseIcon></button>
      <slot></slot>
      <div class="actions">
        <slot name="actions" v-if="!hideActions">
          <button v-on:click.prevent="close()">OK</button>
        </slot>
      </div>
    </div>
  </div>

</template>

<script>
import CloseIcon from '../CloseIcon.vue';

export default {
  name: 'overlayWindow',
  data() {
    return {
      initialX: 0,
      initialY: 0,
      initialMouseX: 0,
      initialMouseY: 0,
      currentMouseX: 0,
      currentMouseY: 0,
      currentX: 0,
      currentY: 0,
      offsetX: 0,
      offsetY: 0,
      mousePressed: false,
      window: null
    }
  },
  components: {CloseIcon},
  props: {
    size: {required: false, default: "medium"}, //medium large
    hideActions: {default: false},
  },
  methods: {
    close () {
      this.$emit('done')
    },
    mousePressedOnWindow(e) {
      this.mousePressed = true
      this.initialMouseX = e.clientX
      this.initialMouseY = e.clientY
    },
    touchPressedOnWindow(e) {
      this.mousePressed = true
      this.initialMouseX = e.changedTouches[0].clientX
      this.initialMouseY = e.changedTouches[0].clientY
      e.preventDefault()
    },
    mouseNotPressedOnWindow() {
      this.mousePressed = false
    },
    mouseMove(e) {
      if(this.mousePressed) {
        this.currentMouseX = e.clientX
        this.currentMouseY = e.clientY
        this.offsetX = this.currentMouseX - this.initialMouseX
        this.offsetY = this.currentMouseY- this.initialMouseY
        this.window.style.top = this.initialY + this.offsetY+"px";
        this.window.style.left = this.initialX + this.offsetX+"px";

      }

    },
    touchMove(e) {
      if(this.mousePressed) {
        this.currentMouseX = e.changedTouches[0].clientX
        this.currentMouseY = e.changedTouches[0].clientY
        this.offsetX = this.currentMouseX - this.initialMouseX
        this.offsetY = this.currentMouseY- this.initialMouseY
        this.window.style.top = this.initialY + this.offsetY+"px";
        this.window.style.left = this.initialX + this.offsetX+"px";

      }
    },
    mouseUp(e) {
      this.mousePressed = false
      this.initialX += this.offsetX
      this.initialY += this.offsetY

    },
  },
  unmounted() {
    window.removeEventListener('mousemove', this.mouseMove)
    window.removeEventListener('touchmove', this.touchMove)
    window.removeEventListener('mouseup', this.mouseUp)

  },
  mounted() {
    window.addEventListener('mousemove', this.mouseMove)
    window.addEventListener('touchmove', this.touchMove)
    window.addEventListener('mouseup', this.mouseUp)
    this.window = this.$refs.window;
  }
}
</script>

<style lang="scss" scoped>

.overlayWindow {
  position: fixed;
  display: flex;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  justify-content: center;
  align-items: center;
  pointer-events: none;

}

.content {
  pointer-events: all;
  position: relative;
  z-index: 100;
  background: white;
  padding: $sp * 2;
  padding-top: 0;
  border: 1px solid rgba(0,0,0,0.1);
  z-index: 2;
  min-width: 33vw;
  max-height: calc(100vh - ($sp * 4));
  overflow-y: auto;
  box-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}
.content.medium {
  max-width: 60em;
}
.content.large {
  width: calc(100% - ($sp * 2));
  max-width: 60em;
}
h3 {
  border-bottom: 1px solid $navbar-default-border;
  padding-bottom: $sp;
  margin-left: -2 * $sp;
  padding-left: 2 * $sp;
  margin-right: -2 * $sp;
  padding-right: 2 * $sp;
  margin-top: $sp;
  cursor: grab;
}
h3.grabbing {
  cursor: grabbing;
}


.actions {
  margin-top: $sp * 3;
  text-align: center;
  button {
    min-width: 8em !important;
  }
}

.close, .close:focus, .close:active {
  position: absolute;
  top: $sp;
  right: $sp;
  outline: none !important;
  box-shadow: none;
  background: transparent;
}

</style>
